import { create } from 'zustand';

import { IVALID_TYPES, VALID_TYPES } from '@src/constants';

interface AppointmentTypesState {
	appointmentTypes: Record<string, string> | null;
	validTypes: IVALID_TYPES[];
	setValidTypes: (types: IVALID_TYPES[]) => void;
	setAppointmentTypes: (types: Record<string, string>) => void;
	clearAppointmentTypes: () => void;
}

export const useAppointmentTypesStore = create<AppointmentTypesState>((set) => ({
	appointmentTypes: null,
	validTypes: VALID_TYPES,
	setAppointmentTypes: (types) => set({ appointmentTypes: types }),
	setValidTypes: (types) => set({ validTypes: types }),
	clearAppointmentTypes: () => set({ appointmentTypes: null }),
}));
